var map = {
	"./balance_icon_down.svg": [
		37291,
		[
			291
		]
	],
	"./balance_icon_up.svg": [
		20740,
		[
			740
		]
	],
	"./kajot_logo.svg": [
		95955,
		[
			955
		]
	],
	"./kajot_planet.svg": [
		35332,
		[
			332
		]
	],
	"./logo_kajot.svg": [
		3935,
		[]
	],
	"./logo_new.svg": [
		21658,
		[]
	],
	"./logo_new_inverted.svg": [
		622,
		[
			622
		]
	],
	"./preloader_logo.svg": [
		95748,
		[
			748
		]
	],
	"./preloader_shine.svg": [
		20802,
		[
			802
		]
	],
	"./sprite.svg": [
		38475,
		[
			475
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 55664;
module.exports = webpackAsyncContext;